import { createRouter, createWebHistory } from 'vue-router';

import store from '../store';

import Layout from '@/containers/layout/index.vue';

const routes = [
  // 404 page must be placed at the end !!!
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index/:token?',
        name: 'Index',
        component: () => import('@/views/index.vue'),
      },
      {
        path: 'theater',
        name: 'Theater',
        component: () => import('@/views/theater.vue'),
      },
      {
        path: 'userCenter',
        name: 'UserCenter',
        component: () => import('@/views/userCenter/userCenter.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'userCenter/accountManagement',
        name: 'AccountManagement',
        component: () => import('@/views/userCenter/accountManagement.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'userCenter/enterpriseInformation',
        name: 'EnterpriseInformation',
        component: () => import('@/views/userCenter/enterpriseInformation.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'userCenter/editResume',
        name: 'EditResume',
        component: () => import('@/views/userCenter/editResume.vue'),
      },
      {
        path: '/specialThanks',
        name: 'SpecialThanks',
        component: () => import('@/views/specialThanks.vue'),
      },
    ],
  },
  {
    path: '/userCenter/evaluation',
    name: 'evaluation',
    component: () => import('@/views/userCenter/evaluation.vue'),
  },
  {
    path: '/cookiePolicy',
    name: 'CookiePolicy',
    component: () => import('@/views/cookiePolicy.vue'),
  },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/privacyPolicy.vue'),
  },
  {
    path: '/termsOfService',
    name: 'TermsOfService',
    component: () => import('@/views/termsOfService.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/index',
  },
];

const routerHistory = createWebHistory();

const router = createRouter({
  history: routerHistory,
  routes,
});

// 导航守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 检查用户是否登录
    if (!store.getters.isAuthenticated) {
      next({ name: 'Index' });
    } else {
      next();
    }
  } else {
    // 特殊处理：如果已登录，访问 /login 则重定向到 /userCenter
    if (to.name === 'Login' && store.getters.isAuthenticated) {
      next({ name: 'UserCenter' });
    } else {
      next();
    }
  }
});

export default router;
